import PropTypes from 'prop-types'
import React from 'react'
import { ArrowButton } from '@plurall/elo'
import Loading from 'plurall-loading'
import { NoResults } from 'components'
import QuestionOptions from './QuestionOptions'

import styles from './QuestionCard.module.scss'

const QuestionCard = ({ question, questionIndex, handleExpandChange }) => (
  <div key={question.id} className={styles.card}>
    <div className={styles['question-header']}>
      <div className={styles['question-select']}>
        <h1>
          {question.title} {`${question.title && '|'} `} Node: {question.id}
        </h1>
      </div>
      <div className={styles['question-expand']}>
        <div className={styles['questions-info']}>
          {question.parent && question.parent.title && (
            <label className={styles['label-info']}>{question.parent.title}</label>
          )}
          {question.disciplines &&
            question.disciplines.map((discipline, index) => (
              <label key={discipline.id} className={styles['label-info']}>
                {`${question.parent && question.parent.title ? '| ' : ''}${discipline.name}${
                  index + 1 === question.disciplines.length ? '' : ','
                } `}
              </label>
            ))}
          {question.titleYear && (
            <label className={styles['label-info']}>
              {`${
                (question.parent && question.parent.title) || question.disciplines.length !== 0
                  ? '|'
                  : ''
              } `}
              {question.titleYear.name}
            </label>
          )}
        </div>
        <ArrowButton
          direction={question.expand ? 'up' : 'down'}
          onClick={() => handleExpandChange(question, questionIndex)}
        />
      </div>
    </div>
    {question.expand && (
      <div className={styles.expand}>
        {question.loading ? (
          <div className={styles.loading}>
            <Loading logoMaxHeight='100' logoMaxWidth='100px' opacity='0.5' />
          </div>
        ) : (
          <>
            <div>
              <span
                className={styles.content}
                dangerouslySetInnerHTML={{ __html: question.text }}
              />
            </div>
            {question.subitems &&
              question.subitems.map((subitem, index) => (
                <>
                  <span className={styles.info}>{`Subitem ${index + 1}`}</span>
                  <div className={styles.subitens}>
                    <span
                      key={subitem}
                      className={styles.content}
                      dangerouslySetInnerHTML={{ __html: subitem }}
                    />
                  </div>
                </>
              ))}

            {question?.options.length > 0 && <QuestionOptions options={question.options} />}

            {question.answerText && (
              <div className={styles.answers}>
                <label className={styles.info}> Gabarito comentado </label>
                <span
                  className={styles.content}
                  dangerouslySetInnerHTML={{ __html: question.answerText }}
                />
              </div>
            )}
            {question.resolutionTeacher && (
              <div className={styles.answers}>
                <label className={styles.info}> Gabarito professor </label>
                <span
                  className={styles.content}
                  dangerouslySetInnerHTML={{ __html: question.resolutionTeacher }}
                />
              </div>
            )}
            {question.answerVideo && (
              <div className={styles.answers}>
                <label className={styles.info}> Gabarito em vídeo </label>
                <span
                  className={styles.content}
                  dangerouslySetInnerHTML={{ __html: question.answerVideo }}
                />
              </div>
            )}
            {question.tags && question.tags.length !== 0 && (
              <div className={styles.answers}>
                <label className={styles.info}> Tags </label>
                {question.tags.map((tag, index) => (
                  <label className={styles.content} key={tag.id}>
                    {`${tag}${index + 1 === question.tags.length ? '' : ','} `}
                  </label>
                ))}
              </div>
            )}
            {question.noResult && <NoResults subTitle='' />}
          </>
        )}
      </div>
    )}
  </div>
)

QuestionCard.propTypes = {
  question: PropTypes.object.isRequired,
  questionIndex: PropTypes.number.isRequired,
  handleExpandChange: PropTypes.func.isRequired,
}

export default QuestionCard
